import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

export default function PageShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-background">
      <PublicNav />
      <div className="mx-auto max-w-4xl px-4 sm:px-6 py-16 sm:py-20">
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tighter">{title}</h1>
        {subtitle && <p className="mt-4 text-base text-muted-foreground leading-relaxed max-w-2xl">{subtitle}</p>}
        <div className="mt-10">{children}</div>
      </div>
      <Footer />
    </div>
  );
}
